// websocket.js
import { websocketUrl } from '@/config/env';
import { getStore } from '@/utils/store';


class WebSocketService {
  constructor(url) {
    this.url = url;
    this.socket = null;
    this.callbacks = [];
  }

  connect() {
    if (this.socket) {
      this.socket.close();
      this.socket = undefined;
    }
    this.socket = new WebSocket(this.url);

    this.socket.onopen = () => {
      console.log('WebSocket connection opened');
      const languageKey = getStore({
        name: 'language',
        type: 'string',
      });
      const userInfo = getStore({
        name: 'userInfo',
        type: 'object',
      })
      this.socket.send(JSON.stringify({
        "accept-Language": languageKey,
        "method":"alarm",
        userId: userInfo.user_id
      }))
      this.callbacks.forEach(callback => callback('open'));
    };

    this.socket.onmessage = (event) => {
      // console.log('WebSocket message received:', event.data);
      this.callbacks.forEach(callback => callback('message', event.data));
    };

    this.socket.onclose = () => {
      console.log('WebSocket connection closed');
      this.callbacks.forEach(callback => callback('close'));
    };

    this.socket.onerror = (error) => {
      console.error('WebSocket error:', error);
      this.callbacks.forEach(callback => callback('error', error));
    };
  }

  send(message) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(message);
    } else {
      console.error('WebSocket is not open. Ready state:', this.socket ? this.socket.readyState : 'null');
    }
  }

  on(event, callback) {
    this.callbacks.push((eventType, data) => {
      if (eventType === event) {
        callback(data);
      }
    });
  }
}

export const webSocketService = new WebSocketService(websocketUrl);